import React from 'react';
import { SurveyCategory, SurveyQuestion } from '../../../config/surveys/schema';
import SidebarQuestionItem from './SidebarQuestionItem';

interface SidebarCategorySectionProps {
  category: SurveyCategory;
  questions: SurveyQuestion[];
  questionStartIndex: number;
  currentQuestionId: string | null;
  answeredQuestionIds: Set<string>;
  accessibleQuestionIds: Set<string>;
  onQuestionClick: (sectionIndex: number) => void;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

const SidebarCategorySection: React.FC<SidebarCategorySectionProps> = ({
  category,
  questions,
  questionStartIndex,
  currentQuestionId,
  answeredQuestionIds,
  accessibleQuestionIds,
  onQuestionClick,
  isExpanded,
  onToggleExpand,
}) => {
  const answeredCount = questions.filter(q => answeredQuestionIds.has(q.id)).length;
  const totalCount = questions.length;

  return (
    <div className={`category-section ${isExpanded ? 'expanded' : ''}`}>
      <button className="category-header" onClick={onToggleExpand}>
        <div className="category-info">
          <span className="category-name">{category.name}</span>
          <span className="category-progress">{answeredCount}/{totalCount}</span>
        </div>
        <span className="category-chevron">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M2.5 4.5L6 8L9.5 4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </span>
      </button>
      <div className="category-questions">
        {questions.map((question, idx) => {
          const globalIndex = questionStartIndex + idx;
          const sectionIndex = globalIndex + 1; // +1 for intro section
          return (
            <SidebarQuestionItem
              key={question.id}
              question={question}
              questionNumber={globalIndex + 1}
              sectionIndex={sectionIndex}
              isCurrent={question.id === currentQuestionId}
              isAnswered={answeredQuestionIds.has(question.id)}
              isAccessible={accessibleQuestionIds.has(question.id)}
              onClick={() => onQuestionClick(sectionIndex)}
            />
          );
        })}
      </div>
    </div>
  );
};

export default SidebarCategorySection;
